
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pelatihan-mandiri/contextualized-learning/[contextualizedPageId]",
      function () {
        return require("private-next-pages/pelatihan-mandiri/contextualized-learning/[contextualizedPageId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pelatihan-mandiri/contextualized-learning/[contextualizedPageId]"])
      });
    }
  